import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-small",
  "use": "icon-arrow-small-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrow-small\"><path d=\"M225.92 385.92c16.64-16.64 43.52-16.64 60.16 0L512 611.84l225.92-225.92a42.56 42.56 0 1 1 60.16 60.16l-233.344 233.408a74.56 74.56 0 0 1-105.472 0L225.92 446.08a42.56 42.56 0 0 1 0-60.16z\" fill=\"#2F54EB\" p-id=\"7314\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol